module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_stores@2x-f0d3b11cdd710f463dc7d03032627cc9.webp";